"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const si_1 = require("../si");
const url_1 = require("../url");
const EXCHANGE_RATES_API_URL = "https://api.exchangeratesapi.host/latest";
const fetchExchangeRates = async (base = si_1.Currency.CZK) => {
    const url = url_1.appendQueryParameters(EXCHANGE_RATES_API_URL, {
        base,
        source: "ecb "
    });
    const { data } = await axios_1.default.get(url);
    return data;
};
exports.default = fetchExchangeRates;
